import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import { ConsolidateRequestStatus } from '../../types/portfolioOrder';

export const consolidateRequestStatusToInfo: {
  [prop in ConsolidateRequestStatus]: {
    color: 'error' | 'info' | 'success' | 'warning';
    icon: React.ElementType;
    menuAction: string;
  };
} = {
  [ConsolidateRequestStatus.CREATED]: {
    color: 'info',
    menuAction: 'Change to Created',
    icon: InfoIcon,
  },
  [ConsolidateRequestStatus.IN_PROGRESS]: {
    color: 'info',
    menuAction: 'Change to In Progress',
    icon: InfoIcon,
  },
  [ConsolidateRequestStatus.REJECTED]: {
    color: 'error',
    menuAction: 'Reject',
    icon: CheckCircleIcon,
  },
  [ConsolidateRequestStatus.EXECUTED]: {
    color: 'success',
    menuAction: 'Execute',
    icon: CheckCircleIcon,
  },
};
